import { useState } from "react";
import { TopBar } from "@/components/layout";
import TaskList from "@/components/tasks/TaskList";
import TaskDetail from "@/components/tasks/TaskDetail";
import NewTaskForm from "@/components/tasks/NewTaskForm";

type View = "list" | "detail" | "new";

const TasksPage = () => {
  const [view, setView] = useState<View>("list");
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null);

  const handleSelectTask = (taskId: string) => {
    setSelectedTaskId(taskId);
    setView("detail");
  };

  const handleBack = () => {
    setSelectedTaskId(null);
    setView("list");
  };

  const handleNewTask = () => {
    setView("new");
  };

  const handleTaskCreated = () => {
    setView("list");
  };

  return (
    <>
      <TopBar title="Taski" />
      <div className="flex-1 overflow-auto p-6">
        <div className="max-w-3xl mx-auto">
          {view === "list" && (
            <TaskList
              onSelectTask={handleSelectTask}
              onNewTask={handleNewTask}
              selectedTaskId={selectedTaskId}
            />
          )}

          {view === "detail" && selectedTaskId && (
            <TaskDetail taskId={selectedTaskId} onBack={handleBack} />
          )}

          {view === "new" && (
            <NewTaskForm onBack={handleBack} onCreated={handleTaskCreated} />
          )}
        </div>
      </div>
    </>
  );
};

export default TasksPage;
